export default {
  // map errors
  'wireImports.mapErrors.sendDate': 'Invalid Transaction Date',
  'wireImports.mapErrors.beneficiaryBankCode': 'Invalid Bank Code',
  'wireImports.mapErrors.debitAccountNumber': 'Invalid From Account',
  'wireImports.mapErrors.default':
    'An error has occurred, please contact your administrator or customer service',
  'wireImports.mapErrors.CANNOT_DELETE_WIRE_MAP': '<%=map%> cannot be deleted',
  'wireImports.mapErrors.WIRE_IMPORT_MAP_DOESNT_EXIST': '<%=map%> previously deleted',
  'wireImports.mapErrors.MAP_NOT_FOUND': 'Import map does not found',
  'wireImports.mapErrors.DELIMITER_AND_END_OF_RECORD_MISMATCH':
    'Delimiter and End of Record selections cannot be the same.',
  'wireImports.title.blanks': 'Blanks',
  'wireImports.title.zeros': 'Zeros',
  'wireImports.groupTitle.fieldPosition': 'Field Position on import',
  'wireImports.groupTitle.trimLeading': 'Trim Leading',
  'wireImports.messageRow.message': 'Replacement Value is used in place of Field Position',

  // CreateImportMap
  'wireImports.createImportMap': 'Create Import Map <%=determinedFor%>',
  'wireImports.modifyImportMap': 'Modify Import Map <%=determinedFor%>',
  'wireImports.delimitedFileMap': 'Delimited File Map',
  'wireImports.domesticWire': 'Domestic Wire',
  'wireImports.internationalWire': 'International Wire',
  'wireImports.addTransactions': 'Add Transactions',
  'wireImports.forDomesticWire': 'For Domestic Wire',
  'wireImports.forInternationalWire': 'For International Wire',
  'wireImports.forACH': 'For ACH',
  'wireImports.updateTransactions': 'Update Transactions',
  'wireImports.deleteUnmatchedTransactions': 'Delete Unmatched Transactions',
  'wireImports.ach': 'ACH',
  'wireImports.createDelimitedMap': 'Create Delimited Map',
  'wireImports.selectPaymentType': 'Select Payment Type',
  'wireImports.selectMapType': 'Select Map Type',
  'wireImports.chooseAllThatApply': '(choose all that apply)',
  'wireImports.errorSelectMapType': 'Please select at least one map type.',

  // CreateACHImportMap
  'wireImports.mapName': 'Map Name',
  'wireImports.endOfRecordMethod': 'End of Record Method',
  'wireImports.mapNameMustBeUnique': 'Map name already exists',
  'wireImports.delimiter': 'Delimiter',
  'wireImports.endOfRecord': 'End of record',
  'wireImports.skipHeaderRecords': 'Skip Header Record(s)',
  'wireImports.skipFirstHeaderRecords': 'Skip First Header Record',
  'wireImports.stripQuotesAroundFields': 'Strip Quotes Around Fields',
  'wireImports.LoadZero': 'Load Zero to Amount Fields',
  'wireImports.partialFileImport': 'Allow Partial File Import',
  'wireImports.sameDelimiterError': 'Delimited value cannot be the same as End of record',
  'wireImports.sameEndOfRecordError': 'End of record value cannot be the same as Delimited value',
  'wireImports.transactionCode': 'Transaction Code',
  'wireImports.transactionType': 'Transaction Type',
  'wireImports.accountType': 'Account Type',
  'wireImports.routingNumber': 'Bank Code / Number',
  'wireImports.count': 'Count',
  'wireImports.useDecimal': 'use decimal',
  'wireImports.addSeparator': 'add separator',

  'wireImports.discData': 'Disc Data',
  'wireImports.fieldName': 'Field name',
  'wireImports.positionInImportFile': 'Position in import file',
  'wireImports.valueInImportFile': 'Value in import file',
  'wireImports.addValue': 'Add Value',
  'wireImports.addValue.field': '<%=fieldName%> Add Value',
  'wireImports.replacementValue': 'Replacement Value',
  'wireImports.replacementValue.field': '<%=fieldName%> Replacement Value',
  'wireImports.addValueExplanation': 'If data is constant value, but is not located in the file.',
  'wireImports.duplicateField': 'Duplicate field',
  'wireImports.invalidBankCode': 'Invalid Bank Code',
  'wireImports.mapHasBeenCreated': 'Import Map %map has been created.',
  'wireImports.mapHasBeenModified': 'Import Map %map has been modified.',
  'wireImports.mapHasFailedToCreate': 'Import Map %map has failed to create',
  'wireImports.mapHasFailedToModify': 'Import Map %map has failed to modify',
  'wireImports.mustBeGraterThanOne': 'Value must be equal or greater than 1',
  'wireImports.mustBeGraterThanZero': 'Value must be equal or greater than 0',
  'wireImports.canNotBeGrater15': 'Value cannot be greater than 15',

  // ViewACHImportMap
  'wireImports.viewImportMap': 'View Import Map <%=determinedFor%>',
  'wireImports.canNotCreateMap': 'Import map cannot be created',
  'wireImports.canNotModifyMap': 'Import map cannot be modified',
  'wireImports.canNotDeleteMap': 'Import map cannot be deleted',
  'wireImports.mapDetails': 'Map Details',
  'wireImports.mapParameters': 'Map Parameters',

  'wireImports.deleteMapDoYouWishToProceed':
    'This action cannot be undone. Do you wish to proceed?',
  'wireImports.match': 'Match',
  'wireImports.update': 'Update',
  'wireImports.atLeastOneUpdateSelectedError':
    'At least one field must be checked in "Update" column',
  'wireImports.atLeastOneMatchSelectedError':
    'At least one field must be checked in "Match" column',
  'wireImports.atLeastOneMatchOrUpdateSelectedError':
    'At least one field must be checked in "Update" column and "Match" column,  Position or Replacement Value must be specified for "Match" and "Update".',
  'wireImports.matchRequiresPositionOrAddValueError':
    'Please establish the <%=fieldNames%> field position<%=ending%> or replacement value<%=ending%>.', // fieldNames = fieldName1, fieldName2,...

  // mapFormats
  'wireImports.mapFormat': 'Map Format',
  'wireImports.startPosition': 'Start Position',
  'wireImports.delimited': 'Delimited format',
  'wireImports.fixed': 'Fixed format',
  'wireImports.recordLength': 'Record length',
  'wireImports.valueMustBeEqual': 'Value must be equal <%=fixedValue%>',
  'wireImports.fieldAOverlapsFieldB': '<%=fieldA%> overlaps <%=fieldB%>.',
  'wireImports.startingPositionIsGreaterThanRecordLength':
    'Starting position is greater than record length',
  'wireImports.endingPositionIsGreaterThanRecordLength':
    'Ending position is greater than record length',

  // processModes
  'wireImports.ADD_ONLY': 'Add Only',
  'wireImports.ADD_AND_UPDATE': 'Add and Update',
  'wireImports.UPDATE_ONLY': 'Update Only',

  // stepper
  'wireImports.mustSelectPaymentType': 'Please select payment type.',
  'wireImports.mustSelectMapFormat': 'Please select map type.',

  // TransactionRow
  'wireImports.switchTo': 'Switch to <%=destination%>',
  'wireImports.credit': 'Credit',
  'wireImports.debit': 'Debit',
  'wireImports.prenote': 'Prenote',
  'wireImports.prenoteCredit': 'Prenote for Credit',
  'wireImports.prenoteDebit': 'Prenote for Debit',
  'wireImports.checking': 'Checking',
  'wireImports.saving': 'Saving',
  'wireImports.loan': 'Loan',
  'wireImports.generalLedger': 'General Ledger',
  'wireImports.uniqueTranTypePerMap': 'Value must be unique for the map',

  // validation
  'wireImports.specifyAccountTypeAndTranType':
    'Please specify both Transaction Type and Account Type.',
  'wireImports.specifyAccountType': 'Please specify Account Type.',
  'wireImports.specifyTranType': 'Please specify Transaction Type.',

  'wireImports.specifyValueForTranType': 'Please specify at least one value for Transaction Type.',
  'wireImports.specifyValueForAccountType': 'Please specify at least one value for Account Type.',

  'wireImports.specifyPositionForTranType':
    'Please specify position in import file for Transaction Type.',
  'wireImports.specifyPositionForAccountType':
    'Please specify position in import file for Account Type.',
  'wireImports.valueInImportFileCannotBeBlank': 'Value in import file field(s) cannot be blank.',
  'wireImports.mapNameAlreadyUsed': 'Map name already used',
  'wireImports.updateIsoAddress':
    'System requires new address fields for wire payments. Please update the import map to include these new fields.',

  // api error
  'wireImports.apiErrors.invalidMapName': 'No special characters in "Map Name"',
  'wireImports.apiErrors.noSpecialCharacters': 'No special characters',
  'wireImports.apiErrors.removeColonOrHyphen': 'Remove colon or hyphen'
};
